import VoucherTypeEnum from 'Enum/voucherType'

const VoucherTypeList = [
  {
    text: 'evoucher.status.notUseYet',
    value: VoucherTypeEnum.VOUCHER_NOT_USE_YET
  },
  {
    text: 'voucherManagement.status.waitingUse',
    value: VoucherTypeEnum.VOUCHER_WAITING_USE
  },
  {
    text: 'voucherManagement.status.expired',
    value: VoucherTypeEnum.VOUCHER_EXPIRED
  },
  {
    text: 'voucherManagement.status.used',
    value: VoucherTypeEnum.VOUCHER_USED
  }
]
const DOMAIN_BASE_PATH = window.location.protocol + '//' + window.location.host + process.env.VUE_APP_BASE_PATH

const GenderList = [
  {
    text: 'profile.genderType.male',
    value: 1
  },
  {
    text: 'profile.genderType.female',
    value: 2
  },
  {
    text: 'profile.genderType.other',
    value: 3
  }
]

const ObjectSettingKey = {
  DISCOUNT: 'discount',
  SUPPLIER_ACTIVE_CODE: 'supplier_active_code',
  HAS_PERM_CREATE_PROMOTION_VOUCHER: 'has_perm_create_promotion_voucher',
  COMPANY_NAME: 'company_name',
  COMPANY_ADDRESSS: 'company_addresss',
  COMPANY_EMAIL: 'company_email',
  COMPANY_HOTLINE: 'company_hotline',
  COMPANY_FACEBOOK: 'company_facebook',
}

export default {
  VoucherTypeList,
  DOMAIN_BASE_PATH,
  GenderList,
  ObjectSettingKey
}
